import VendorInvoiceCreditsHtml from './templates/vendor-invoice-credits.html';

export function VendorInvoiceCreditsDirective () {
  return {
    controller: 'VendorInvoiceCreditsCtrl',
    restrict: 'E',
    templateUrl: VendorInvoiceCreditsHtml,
    scope: {
      credits: '=',
      invoice: '='
    }
  }
}